var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"float",attrs:{"href":`https://api.whatsapp.com/send?phone=${_vm.phone}&text=${_vm.text}`,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"my-float",attrs:{"icon":"fa-brands fa-whatsapp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }